export const POWER_PIVOT_LIBRARY_ITEM_TYPES = {
  DynamicExcelChart: 800,
  DynamicExcelNamedRange: 801,
  DynamicExcelCellRange: 802,
};

export const isPowerPivotLibraryItem = (libraryItemType: number): boolean =>
  Object.values(POWER_PIVOT_LIBRARY_ITEM_TYPES).indexOf(libraryItemType) !== -1;
